// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"0f6ae76b","401":"829ec1bd","496":"0e7d87e1"}[chunkId] + ".chunk.js";
};